export default function isCssIdGood( id ) {
	const numberRex = /\d+/

	const blockedIds = [
		'widget',
		"recentcomments",
		'fws_([a-zA-Z0-9_-]+)', // 3 party plugin dynamic ID
		'wrapper-[a-zA-Z-0-9]{16,16}' // headway dynamic ID
	]

	// Blocked id checks.
	if ( id != '' ) {
		// Check if a blocked ID.
		for ( let f = 0; f < blockedIds.length; f++ ) {
			if ( regexStringByFilter( blockedIds[ f ], id ) ) {
				return false
			}
		}
	}

	/* ---------------------------------------------------- */
	/* GOOD ALLOWED NUMMERIC IDS                            */
	/* ---------------------------------------------------- */
	/* Stylist allow just the following nummeric ids        */
	/* Ex: #section-15 is a allowed nummeric id             */
	/* ---------------------------------------------------- */
	const allowedDigitalIds = [

		// General
		'([a-zA-Z0-9_-]+)?module([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?slide([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?section([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?row([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?layout([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?form([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?wrapper([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?container([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?parallax([a-zA-Z0-9_-]+)?',
		'([a-zA-Z0-9_-]+)?block([a-zA-Z0-9_-]+)?',

		// 3 party plugin allowed ids
		'layers-widget-([a-zA-Z0-9_-]+)?',
		'builder-module-([a-zA-Z0-9_-]+)?',
		'pg-([a-zA-Z0-9_-]+)?',
		'ptpb_s([a-zA-Z0-9_-]+)?',
		'billing_address_([0-9])([a-zA-Z0-9_-]+)?', // woocommerce
		'el-([a-zA-Z0-9_-]+)',
		'dslc-module-([a-zA-Z0-9_-]+)', // Live Composer
		'module-([0-9]){13,13}-([0-9]){4,4}', // upfront
		'wrapper-([0-9]){13,13}-([0-9]){4,4}' // upfront
	];

	// Check if ID has number.
	if ( numberRex.test( id ) ) {
		// Allow only particular digital ids.
		// let isIdAllowed = false

		// This id in the allowed list?
		for ( let d = 0; d < allowedDigitalIds.length; d++ ) {
			// Yes:
			if ( regexStringByFilter( allowedDigitalIds[ d ], id ) ) {
				// Good numeric ID.
				return true
			}
		}

		// Bad numeric ID.
		return false
	}

	// Good non-number and not blocked ID.
	return true
}

function regexStringByFilter( filter, string ) {
	// Regex
	var r = new RegExp("(\\s|^)" + filter + "(\\s|$)","gi");

	// has
	if ( r.test( string ) ) {
		return true;
	} // not have
		return false;
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/is-css-id-good.js